'use strict';

const libPictView = require('pict-view');

const DD_CSS = /*css*/`
	.dd-wrap { max-width: 1100px; margin: 0 auto; padding: 1.5rem 1.25rem 3rem; }
	.dd-head { margin: 0 0 1.5rem; }
	.dd-eyebrow { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: var(--theme-color-brand-secondary, #6b7686); }
	.dd-title { font-size: 1.7rem; font-weight: 700; color: var(--theme-color-text-primary, #1f2733); margin: 0.15rem 0 0; }
	.dd-intro { font-size: 0.95rem; color: var(--theme-color-text-secondary, #45505f); margin: 0.5rem 0 0; max-width: 60ch; }
	.dd-app { border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 12px; background: var(--theme-color-background-panel, #fff); padding: 1.25rem 1.35rem 1.4rem; margin: 0 0 1.25rem; }
	.dd-app-head { display: flex; align-items: center; gap: 0.85rem; }
	.dd-app-icon { flex: 0 0 auto; width: 2.6rem; height: 2.6rem; border-radius: 10px; display: inline-flex; align-items: center; justify-content: center; font-size: 1.25rem; color: #fff; background: var(--theme-color-brand-primary, #5650e6); }
	.dd-app-name { font-size: 1.1rem; font-weight: 650; color: var(--theme-color-text-primary, #1f2733); }
	.dd-app-meta { font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #8a94a3); }
	.dd-app-blurb { font-size: 0.9rem; color: var(--theme-color-text-secondary, #45505f); margin: 0.8rem 0 1.1rem; max-width: 66ch; }
	.dd-builds { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 0.7rem; }
	.dd-build { display: flex; align-items: center; gap: 0.75rem; padding: 0.7rem 0.85rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 9px; background: var(--theme-color-background-primary, #fff); text-decoration: none; color: inherit; transition: border-color 0.12s, background 0.12s, box-shadow 0.12s; }
	.dd-build:hover { border-color: var(--theme-color-brand-primary, #5650e6); background: var(--theme-color-background-secondary, #f5f6fb); box-shadow: 0 1px 4px rgba(86,80,230,0.12); }
	.dd-build-os { flex: 0 0 auto; width: 2rem; height: 2rem; border-radius: 7px; display: inline-flex; align-items: center; justify-content: center; font-size: 1.05rem; color: var(--theme-color-text-primary, #1f2733); background: var(--theme-color-background-tertiary, #eef0f4); }
	.dd-build-text { display: flex; flex-direction: column; min-width: 0; flex: 1 1 auto; }
	.dd-build-title { font-size: 0.9rem; font-weight: 650; color: var(--theme-color-text-primary, #1f2733); }
	.dd-build-sub { font-size: 0.74rem; color: var(--theme-color-text-muted, #8a94a3); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
	.dd-build-dl { flex: 0 0 auto; color: var(--theme-color-brand-primary, #5650e6); font-size: 0.95rem; }
	.dd-gated { text-align: center; border: 1px dashed var(--theme-color-border-medium, #c8cfd8); border-radius: 12px; background: var(--theme-color-background-secondary, #f5f6fb); padding: 2.75rem 1.5rem; }
	.dd-gated-icon { font-size: 1.6rem; color: var(--theme-color-text-muted, #8a94a3); margin-bottom: 0.6rem; }
	.dd-gated-title { font-size: 1.05rem; font-weight: 650; color: var(--theme-color-text-primary, #1f2733); }
	.dd-gated-body { font-size: 0.9rem; color: var(--theme-color-text-secondary, #45505f); margin: 0.4rem auto 0; max-width: 46ch; }
`;

/**
 * DataDownloader — the bespoke #/Datalake/DataDownloader screen. A thin shell; the DataDownloaderProvider builds
 * the download cards into #DD-Body (and the gated notice when the customer's module isn't enabled).
 */
class DataDownloader extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.DataDownloaderProvider; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider) { tmpProvider.render(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = DataDownloader;

module.exports.default_configuration =
{
	ViewIdentifier: 'DataDownloader',
	DefaultRenderable: 'DataDownloaderWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: DD_CSS,
	Templates:
	[
		{
			Hash: 'DataDownloader-Wrap',
			Template: /*html*/`<div class="dd-wrap"><div id="DD-Body"></div></div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'DataDownloaderWrap',
			TemplateHash: 'DataDownloader-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};
